import { usePage } from "@inertiajs/react";
import {
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";

import { DispatchProps } from "../../hooks/useModalDispatch";
import StyleWrapper from "../../widget/StyleWrapper";

import ModalWrapper from "./ModalWrapper";

export interface ModalContextProps {
  onClose?: () => void;
}

export type SharedModalProps<T = void> = T & {
  handleClose: () => void;
};
export type ModalRenderProps = Record<string, unknown>;
export type ModalRenderer<P = ModalRenderProps> = FC<P> | undefined;
export type ModalState<P = ModalRenderProps> =
  | []
  | [
      modalComponent?: ModalRenderer<P>,
      modalProps?: DispatchProps<P>,
      contextProps?: ModalContextProps,
    ];
export type ModalDispatch<P = ModalRenderProps> = Dispatch<
  SetStateAction<ModalState<P>>
>;
export type ModalContext<P = ModalRenderProps> = [
  ModalDispatch<P>,
  ModalState<P>,
];

export const ModalContext = createContext<ModalContext>({} as ModalContext);

const ModalContextProvider = ({
  children,
  theme,
}: PropsWithChildren<{ theme?: string }>) => {
  const { url } = usePage();
  const [state, setModal] = useState<ModalState>([]);

  useEffect(() => {
    setModal([]);
  }, [url]);

  return (
    <ModalContext.Provider value={[setModal, state]}>
      {children}
      {theme ? (
        <StyleWrapper>
          <ModalWrapper />
        </StyleWrapper>
      ) : (
        <ModalWrapper />
      )}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
